
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trafficbox/privacy-policy",
      function () {
        return require("private-next-pages/trafficbox/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trafficbox/privacy-policy"])
      });
    }
  